<template>
    <div class="row">
        <Main class="col-md-9 pr-0"></Main>
        <Side class="col-md-3 pr-0"></Side>
    </div>
</template>

<script>
        import Main from '@/components/main_page/sub_components/mylog_main.vue'
        import Side from '@/components/main_page/sub_components/mylog_side.vue'

    export default {
        name: "mylog",
        components: {
            Main,
            Side,
        },
    }
</script>

<style scoped>

</style>